<template>
  <div class="grid pb-0">
    <div class="grid-title">
      <h4>{{ $t("DYNAMIC_RESTRICTION") }}</h4>
      <div>
        <v-row>
          <v-col class="text-right pt-0 pb-0">
            <v-btn color="primary" @click="addNew">
              <v-icon dark size="18" class="mr-2"> mdi-plus </v-icon>
              {{ $t("ADD_NEW_DYNAMIC_RESTRICTION") }}
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </div>
    <div class="grid-body border-top-unset">
      <v-row align="center" class="pb-3 pr-3 pl-3">
        <v-col sm="4">
          <v-text-field v-model="keyword" :label="$t('_BOOKING.SEARCH')" v-on:keyup="getAll(true)"
            class="mt-0 pt-0"></v-text-field>
        </v-col>
        <v-col>
          <v-radio-group row v-model="radioGroup" class="mt-0" @change="($event) => filterStatus($event)">
            <v-radio v-for="item in optionFilter" :key="item.key" :label="item.label" :value="item.key"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-progress-linear color="warning" indeterminate rounded height="3" v-if="isLoading"></v-progress-linear>
      <div>
        <v-simple-table>
          <!-- <template v-slot:default> -->
          <thead>
            <tr>
              <th width="2%" class="text-center vertical-middle" scope="col">
                {{ $t("STT") }}
              </th>
              <th class="text-left" scope="col">{{ $t("DYNAMIC_RESTRICTION_NAME") }}</th>
              <th width="15%" class="text-left" scope="col">
                {{ $t("TIME_APPLICATION") }}
              </th>
              <th width="15%" class="text-left" scope="col">{{ $t("TARGET_APPLY") }}</th>
              <th width="15%" class="vertical-middle" scope="col">
                {{ $t("CRITERIA") }}
              </th>
              <th width="10%" class="vertical-middle" scope="col">
                {{ $t("RESTRICTION") }}
              </th>
              <th width="5%" class="text-center vertical-middle" scope="col">
                {{ $t("STATUS") }}
              </th>
              <th width="15%" class="text-center vertical-middle" scope="col">
                {{ $t("ACTION") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-if="dynamicList.length > 0 && !isLoading">
              <tr v-for="(item, i) in dynamicList" :key="i">
                <td width="2%" class="text-center vertical-middle">{{ i + 1 }}</td>
                <td class="font-weight-bold vertical-middle">
                  <a class="app-link text-decoration-none" href="javascript:;" @click="editItem(item)">
                    {{ item.nameVi }}
                  </a>
                </td>
                <td width="15%">
                  {{ formatDate(item.startDate) }} -
                  {{ formatDate(item.endDate) }}
                </td>
                <td width="15%" class="text-left vertical-middle">
                  {{ optionApplyFor.find((e) => e.key === item.appliedFor).label }}
                </td>
                <td width="15%" class="vertical-middle">
                  {{ optionApplyBy.find((e) => e.key === item.appliedBy).label }}
                </td>
                <td width="10%" class="vertical-middle">
                    {{ item.productDTOList.length > 0 ? item.productDTOList[0].dynamicRestrictionRangeDTO.length > 0 ? optionConfigType.find((e) => e.value === item.productDTOList[0].dynamicRestrictionRangeDTO[0].restrictionType).text : '' : '' }}
                </td>
                <td width="5%" class="text-center vertical-middle">
                  <div class="d-flex justify-center">
                    <v-switch v-model="item.active" @change="updateStatus(item)"
                      class="service-status mt-0 pt-0"></v-switch>
                  </div>
                </td>
                <td width="15%" class="text-center vertical-middle">
                  <v-tooltip top transition="slide-y-reverse-transition">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn depressed @click="editItem(item)" x-small class="rounded-sm mr-1" v-bind="attrs" v-on="on"
                        color="primary" outlined>
                        <v-icon size="15"> mdi-pencil </v-icon>
                      </v-btn>
                    </template>
                    {{ $t("EDIT") }}
                  </v-tooltip>
                  <v-tooltip top transition="slide-y-reverse-transition">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn depressed color="primary" @click="copy(item)" x-small v-bind="attrs" v-on="on"
                        class="rounded-sm  mr-1" outlined>
                        <v-icon size="17"> copy_all </v-icon>
                      </v-btn>
                    </template>
                    {{ $t("COPY") }}
                  </v-tooltip>
                  <v-tooltip top transition="slide-y-reverse-transition">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn depressed color="error" @click="$refs.deleteDialogComponent.open(item)" x-small
                        v-bind="attrs" v-on="on" class="rounded-sm mr-1" outlined>
                        <v-icon size="17"> delete </v-icon>
                      </v-btn>
                    </template>
                    {{ $t("DELETE") }}
                  </v-tooltip>
                  <v-menu bottom left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn depressed color="primary" x-small v-bind="attrs" v-on="on" class="rounded-sm  mr-1" outlined>
                        <v-icon size="17">mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>

                    <v-list>
                      <v-list-item>
                        <v-list-item-title>
                          <v-btn depressed color="primary" @click="sort(item, 'PUSH')" x-small class="rounded-sm"
                            :title="$t('PRIOTITY')" outlined>
                            <v-icon size="17"> arrow_upward </v-icon>
                          </v-btn>
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-title>
                          <v-btn depressed color="primary" @click="sort(item, 'POP')" x-small class="rounded-sm" outlined
                            :title="$t('NO_PRIOTITY')">
                            <v-icon size="17"> arrow_downward </v-icon>
                          </v-btn>
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td colspan="8" class="text-center vertical-middle font-weight-bold font-italic" style="color: red">
                  {{ $t("NO_DATA") }}
                </td>
              </tr>
            </template>
          </tbody>
          <!-- </template> -->
        </v-simple-table>
        <paging v-if="paging.total" :paging.sync="paging" @changePage="changePage" class="pl-3 pr-3">
          <span slot="totalItems" v-if="paging">{{ $t("TOTAL") }}: {{ paging.total }}</span>
        </paging>
        <delete-dialog @deleteItem="deleteService" :maxWidth="325" ref="deleteDialogComponent">
          <span slot="title">{{ $t("CONFIRM_DELETE_DYNAMIC_RESTRICTION") }}?</span>
        </delete-dialog>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.table-syncPMS {
  padding: 0;

  .v-card__text {
    padding: 0;
  }
}

#service-list {
  td {
    vertical-align: middle;
  }

  button.sortHandle {
    outline: none;
  }

  .service-status {
    justify-content: center;
    margin-top: 5px;
  }
}
</style>

<script>
import Paging from "@/components/Utils/Paging.vue";
import { _formatCurrency, _formatDate, _alert } from "@/_helpers/function.js";
import DeleteDialog from "@/components/Utils/DeleteDialog.vue";
import ConfirmDialog from "@/components/Utils/ConfirmDialog.vue";
import { dynamicService } from "@/_services/SaleRoom/dynamic-restriction.service.js";
import draggable from "vuedraggable";
const toLower = (text) => {
  return text.toString().toLowerCase();
};
export default {
  components: {
    "delete-dialog": DeleteDialog,
    "confirm-dialog": ConfirmDialog,
    paging: Paging,
    draggable,
  },
  data() {
    return {
      dialog: false,
      dialogActive: false,
      checkAll: false,
      isLoading: false,
      sysLang: this.$i18n.locale || "vi",
      radioGroup: "all",
      selected: [],
      listService: [],
      listFilter: [],
      dragging: false,
      dialog: false,
      paging: {
        total: 0,
        limit: 15,
        offset: 0,
      },
      selected: [],
      optionFilter: [
        {
          label: this.$t("ALL"),
          key: "all",
        },
        {
          label: this.$t("SERVICE.ACTIVE"),
          key: true,
        },
        {
          label: this.$t("SERVICE.DEACTIVE"),
          key: false,
        },
      ],
      keyword: null,
      dynamicList: [],
      orderBy: "active",
      optionApplyFor: [
        {
          label: this.$t("ACCORDING_TO_EACH_ROOM_CLASS"),
          key: 0,
        },
        {
          label: this.$t("ENTIRE_HOTEL"),
          key: 1,
        },
      ],
      optionApplyBy: [
        {
          label: this.$t("ROOM_OCCUPANCY"),
          key: 0,
        },
        {
          label: this.$t("NUMBER_OF_ROOMS_AVAILABLE"),
          key: 1,
        },
      ],
      optionConfigType: [
        {
          text: this.$t("BY_RATE"),
          value: 0,
        },
        {
          text: this.$t("HOTEL_ROOM_TYPE_STOP_SELL"),
          value: 1,
        },
      ],
    };
  },
  created() {
    this.getAll(true);
  },
  methods: {
    formatDate: _formatDate,
    _formatCurrency: _formatCurrency,
    changePage(paging) {
      this.paging = paging;
      this.getAll(false);
    },
    getAll(isSearching) {
      if (isSearching) this.paging.offset = 0;
      let body = {};
      body.keyword = this.keyword;
      if (this.radioGroup === "all") {
        body.status = null;
      } else {
        body.status = this.radioGroup;
      }
      body.limit = this.paging.limit;
      body.offset = this.paging.offset;
      body.orderBy = this.orderBy;
      body.asc = this.asc;
      this.isLoading = true;
      dynamicService
        .getAll(body)
        .then((res) => {
          this.dynamicList = res.data;
          this.paging.total = res.total;
        })
        .finally(() => (this.isLoading = false));
    },
    filterStatus(status) {
      this.getAll(true);
    },
    updateStatus(item) {
      const body = {
        id: item.id,
        status: item.active,
      };
      dynamicService.updateStatus(body).then((res) => {
        _alert(res, this.$t(res.data), false);
        this.getAll(true);
      });
    },

    filterByNameOrCode() {
      this.getAll(true);
    },
    addNew() {
      this.$router.push({ name: "dynammic-restriction-detail", params: { id: 0 } });
    },
    editItem(item) {
      this.$router.push({
        name: "dynammic-restriction-detail",
        params: { id: item.id },
      });
    },
    copy(item) {
      this.$router.push({
        name: "dynammic-restriction-detail",
        params: { id: item.id, type: 'COPY' },
      });
    },
    deleteService(item) {
      dynamicService.removeDynamic(item.id).then((res) => {
        _alert(res, this.$t(res.data), true);
      });
    },
    sort(item, type) {
      const body = {
        id: item.id,
        priority: type === 'PUSH'
      }
      dynamicService.sort(body).then((res) => {
        _alert(res, this.$t(res.data), false);
        this.getAll(true);
      });
    }
  },
};
</script>
